import { ReactNode } from 'react'
import { clsx } from 'clsx'

interface ResponsiveAlignedLayoutProps {
  children: ReactNode
  maxContentWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | '7xl'
  className?: string
  alignment?: 'left' | 'center' | 'right'
}

export const ResponsiveAlignedLayout = ({
  children,
  maxContentWidth = '4xl',
  className,
  alignment = 'center',
}: ResponsiveAlignedLayoutProps) => {
  const maxWidthClass = `max-w-${maxContentWidth}`
  
  const alignmentClass = {
    left: 'mx-0',
    center: 'mx-auto',
    right: 'ml-auto',
  }[alignment]

  return (
    <div className={clsx('w-full', alignmentClass)}>
      <div className={clsx(maxWidthClass, 'w-full', className)}>
        {children}
      </div>
    </div>
  )
}